import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { localBusinessSchema, organizationSchema } from "@/components/SEO";

// Layout
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import GovernmentContractingPage from "@/pages/GovernmentContractingPage";
import AviationPage from "@/pages/AviationPage";
import LogisticsPage from "@/pages/LogisticsPage";
import AerialPhotographyPage from "@/pages/AerialPhotographyPage";
import CertificationsPage from "@/pages/CertificationsPage";
import ContactPage from "@/pages/ContactPage";
import MissionSupportPage from "@/pages/MissionSupportPage";
import AircraftDetailingPage from "@/pages/AircraftDetailingPage";
import MedicalDeliveryPage from "@/pages/MedicalDeliveryPage";
import WebServicesPage from "@/pages/WebServicesPage";
import AircraftBrokeragePage from "@/pages/AircraftBrokeragePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        
        <BrowserRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/government-contracting" element={<GovernmentContractingPage />} />
              <Route path="/aviation" element={<AviationPage />} />
              <Route path="/logistics" element={<LogisticsPage />} />
              <Route path="/aerial-photography" element={<AerialPhotographyPage />} />
              <Route path="/certifications" element={<CertificationsPage />} />
              <Route path="/mission-support" element={<MissionSupportPage />} />
              <Route path="/aircraft-detailing" element={<AircraftDetailingPage />} />
              <Route path="/medical-delivery" element={<MedicalDeliveryPage />} />
              <Route path="/web-services" element={<WebServicesPage />} />
              <Route path="/aircraft-brokerage" element={<AircraftBrokeragePage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
